module.exports = __webpack_public_path__ + "static/media/azure-db.b8452e16.png";